// extracted by mini-css-extract-plugin
export default {"root":"NotificationsReadAllButton_root__gmEfa"};